export default () => {
    // @TODO: implement devWatcher
    /*
    try {
        if (process.env.NODE_ENV !== "development") return // only run in development mode
        new EventSource("/esbuild").addEventListener("change", () => location.reload())
    } catch {
        // ignore
    }
   */
}